import React from 'react';
import {
  Table,
  TableHeader,
  TableBody,
  TableRow,
  TableHead,
  TableCell,
} from '@/components/ui/table';

interface FieldDef {
  key: string;
  abbr: string;
}

interface BreedingValuesTableProps {
  title: string;
  fields: FieldDef[];
  listing: Record<string, any>;
  evaluationType: string;
}

const BreedingValuesTable: React.FC<BreedingValuesTableProps> = ({
  title,
  fields,
  listing,
  evaluationType,
}) => {
  // Only render if at least one field has data
  const hasData = fields.some(
    (f) => listing[f.key] !== null && listing[f.key] !== undefined && listing[f.key] !== ''
  );
  if (!hasData) return null;

  const getVal = (key: string) => {
    const v = listing[key];
    return v !== null && v !== undefined && v !== '' ? String(v) : null;
  };

  return (
    <div className="mb-6 last:mb-0 border rounded-lg overflow-hidden">
      <div className="overflow-x-auto">
        <Table>
          <TableHeader>
            <TableRow className="border-b-0">
              <TableHead
                colSpan={fields.length + 1}
                className="bg-primary text-primary-foreground text-center font-bold text-sm py-2"
              >
                {title}
              </TableHead>
            </TableRow>
            <TableRow>
              <TableHead className="w-20 bg-muted" />
              {fields.map((f) => (
                <TableHead key={f.key} className="text-center font-bold bg-muted/50">
                  {f.abbr}
                </TableHead>
              ))}
            </TableRow>
          </TableHeader>
          <TableBody>
            <TableRow>
              <TableCell className="font-semibold bg-muted whitespace-nowrap">{evaluationType}</TableCell>
              {fields.map((f) => {
                const val = getVal(f.key);
                return (
                  <TableCell key={f.key} className="text-center">
                    {val ?? <span className="text-muted-foreground">-</span>}
                  </TableCell>
                );
              })}
            </TableRow>
            <TableRow>
              <TableCell className="font-semibold bg-muted whitespace-nowrap">ACC</TableCell>
              {fields.map((f) => {
                const val = getVal(`${f.key}_acc`);
                return (
                  <TableCell key={f.key} className="text-center">
                    {val ?? <span className="text-muted-foreground">-</span>}
                  </TableCell>
                );
              })}
            </TableRow>
            <TableRow>
              <TableCell className="font-semibold bg-muted whitespace-nowrap">% Rank</TableCell>
              {fields.map((f) => {
                const val = getVal(`${f.key}_perc_rank`);
                return (
                  <TableCell key={f.key} className="text-center">
                    {val ?? <span className="text-muted-foreground">-</span>}
                  </TableCell>
                );
              })}
            </TableRow>
          </TableBody>
        </Table>
      </div>
    </div>
  );
};

export default BreedingValuesTable;
